export const NUMBER_FIELD_TAG_NAME = "number-field" as const;

export const NUMBER_FIELD_VARIANTS = ["default", "filled"] as const;

export const NUMBER_FIELD_LAYOUTS = ["stacked", "inline", "text"] as const;

export const NUMBER_FIELD_ALIGNS = ["left", "center", "right"] as const;
